import { createFileRoute } from "@tanstack/react-router";
import ExternalRedirect from "@/components/ExternalRedirect";
export const Route = createFileRoute("/youtube")({
  component: YouTubeRedirect,
  head() {
    return {
      meta: [
        {
          title: "YouTube: SAINT® TMS Videos | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Watch SAINT® TMS educational videos from Neuro Wellness in Coral Springs, FL. Learn how fMRI-guided accelerated TMS treats depression in just 5 days.",
        },
        {
          property: "og:title",
          content: "YouTube: SAINT® TMS Videos | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Watch SAINT® TMS educational videos from Neuro Wellness in Coral Springs, FL. Learn how fMRI-guided accelerated TMS treats depression in just 5 days.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/youtube",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/youtube",
        },
      ],
    };
  },
});
function YouTubeRedirect() {
  return (
    <ExternalRedirect to="https://www.youtube.com/@NeuroWellnessCentersofAmerica" />
  );
}
